@if (gallery()) {
  @if (!subPage()) {
    <div class="main-page" [@mainPage]>
      <div class="header">
        <h1>Settings</h1>
        <app-gallery-settings-presets-dropdown [gallery]="gallery()"></app-gallery-settings-presets-dropdown>
      </div>

      <app-gallery-settings-group title="Collaboration" location="new-gallery-settings-menu">
        <app-gallery-status-setting-item [gallery]="gallery()"></app-gallery-status-setting-item>
        <app-asset-status-setting-item
          [gallery]="gallery()"
          (customize)="subPage.set('asset-status')"
        ></app-asset-status-setting-item>
        <app-favorites-setting-item [gallery]="gallery()"></app-favorites-setting-item>
        <app-comments-setting-item [gallery]="gallery()"></app-comments-setting-item>
        @if (gallery().enabled_feedback_options.includes('comment')) {
          <app-annotations-setting-item [gallery]="gallery()" [@dynamicRow]></app-annotations-setting-item>
        }
        <app-color-labels-setting-item
          [gallery]="gallery()"
          (customize)="subPage.set('color-labels')"
        ></app-color-labels-setting-item>
      </app-gallery-settings-group>

      <app-gallery-settings-group title="Download" location="new-gallery-settings-menu">
        <app-gallery-download-setting-item [gallery]="gallery()"></app-gallery-download-setting-item>
        <app-asset-download-setting-item [gallery]="gallery()"></app-asset-download-setting-item>
        @if (gallery().download_full_gallery || gallery().download_single_asset) {
          <app-download-sizes-setting-item
            [gallery]="gallery()"
            (customize)="subPage.set('download-sizes')"
            [@dynamicRow]
          ></app-download-sizes-setting-item>
          <app-gallery-download-approved-only-setting-item
            [gallery]="gallery()"
            [@dynamicRow]
          ></app-gallery-download-approved-only-setting-item>
        }
      </app-gallery-settings-group>

      <app-gallery-settings-group title="General" location="new-gallery-settings-menu">
        <app-gallery-workflow-setting-item [gallery]="gallery()"></app-gallery-workflow-setting-item>
        <app-gallery-metadata-setting-item [gallery]="gallery()"></app-gallery-metadata-setting-item>
        <app-asset-versions-setting-item [gallery]="gallery()"></app-asset-versions-setting-item>
        <app-gallery-watermark-setting-item
          [gallery]="gallery()"
          (customize)="subPage.set('gallery-watermark')"
        ></app-gallery-watermark-setting-item>
      </app-gallery-settings-group>

      <div class="feedback">
        <p>
          Do you have feedback or suggestions?
          <a class="primary-link" [routerLink]="['/a/features']">Contact us</a>
        </p>
      </div>
    </div>
  } @else {
    <div class="sub-page" [@subPage]>
      @if (subPage() === 'asset-status') {
        <app-asset-status-setting-customize
          [gallery]="gallery()"
          (back)="subPage.set(undefined)"
        ></app-asset-status-setting-customize>
      } @else if (subPage() === 'color-labels') {
        <app-color-labels-setting-customize
          [gallery]="gallery()"
          (back)="subPage.set(undefined)"
        ></app-color-labels-setting-customize>
      } @else if (subPage() === 'download-sizes') {
        <app-download-sizes-setting-customize
          [gallery]="gallery()"
          (back)="subPage.set(undefined)"
        ></app-download-sizes-setting-customize>
      } @else if (subPage() === 'gallery-watermark') {
        <app-gallery-watermark-setting-customize
          [gallery]="gallery()"
          (back)="subPage.set(undefined)"
        ></app-gallery-watermark-setting-customize>
      }
    </div>
  }
}
